module.exports = __webpack_public_path__ + "static/media/item_5_35_comp.375e914d.png";